import axios from "axios";
import { API_IP } from "../../global_variables";

/**
 * Fire-and-forget helper – calls the backend to push an FCM notification
 * to a Provider (recipientUserId like "P123") after a Client sends a message.
 *
 * @param {string} recipientUserId  – "P123" (Provider receives the message)
 * @param {string} senderName       – Client's display name shown in notification
 * @param {string} messagePreview   – Message body (truncated to 100 chars)
 * @param {string} channelCode      – Amity channel_code (for deep-linking)
 */
export async function sendChatPushNotification({
  recipientUserId,
  senderName,
  messagePreview,
  channelCode,
}) {
  try {
    const authToken =
      localStorage.getItem("token") || sessionStorage.getItem("token");
    if (!authToken || !recipientUserId) return;

    await axios.post(
      `${API_IP}/api/amity/chat-notify`,
      { recipientUserId, senderName, messagePreview, channelCode },
      {
        headers: { Authorization: `Bearer ${authToken}` },
        timeout: 5000,
      }
    );
  } catch (error) {
    // Non-critical – never block the chat UI
    console.log("[ChatPush] Failed to send push:", error?.message);
  }
}
